import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axiosInstance from "services/AxiosInstance.js";
import { notifySuccess, notifyError } from "jsx/components/CitoPlus/components/CitoPlusToastr";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import { set } from "lodash";
import * as Yup from 'yup';
import { Formik, useFormik } from "formik";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email inválido")
    .required("Campo requerido"),
  identificacion: Yup.string().required("Campo requerido"),
  nombre: Yup.string().required("Campo requerido"),
  apellido: Yup.string().required("Campo requerido"),
  telefono: Yup.string().required("Campo requerido"),
  descripcion: Yup.string().required("Campo requerido"),
  valor: Yup.number().required("Campo requerido"),
  total_impuesto: Yup.number().required("Campo requerido"),
  total: Yup.number().required("Campo requerido"),
  impuesto_valor: Yup.number().required("Campo requerido"),
  impuesto_total: Yup.number().required("Campo requerido"),
  documento_relacionado: Yup.string().required("Campo requerido"),
  info_adicional: Yup.string().required("Campo requerido"),
});


const ModalCrearFacturacionElectronica = ({ show, onHide }) => {

  const URL = `/api/v3/parking/facturacion-electronica/crear-factura/`;

  const initialValues = {
    'email': '',
    'identificacion': '',
    'nombre': '',
    'apellido': '',
    'telefono': '',
    'descripcion': '',
    'valor': '',
    'total_impuesto': '',
    'total': '',
    'impuesto_valor': '',
    'impuesto_total': '',
    'documento_relacionado': '',
    'info_adicional': '',
  }

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(initialValues);

  const handleSubmit = async (values, { setSubmitting }) => {
    const data = {
      ...values,
    }
    setFormValues(data);

    setLoading(true);
    try {
      const response = await axiosInstance.post(URL, data);
      notifySuccess('Factura electrónica creada exitosamente');
      setFormValues(initialValues);
      onHide(true);
    } catch (error) {
      handleErrors(error);
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Crear Factura Electrónica</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center p-4">
            <SpinnerCitoPlus text="Creando factura electrónica..." />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Crear Factura Electrónica</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={false}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (
            <Form
              className="form-valide"
              onSubmit={handleSubmit}
            >
              <Form.Group controlId="identificacion">
                <Form.Label>Identificación</Form.Label>
                  <Form.Control
                    type="text"
                    name="identificacion"
                    value={values.identificacion}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.identificacion && !!errors.identificacion}
                  />
                    {errors.identificacion && touched.identificacion && (
                      <div className="text-danger">{errors.identificacion}</div>
                    )}
              </Form.Group>

              <Form.Group controlId="nombre">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={values.nombre}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.nombre && !!errors.nombre}

                />
                {errors.nombre && touched.nombre && (
                  <div className="text-danger">{errors.nombre}</div>
                )}
              </Form.Group>

              <Form.Group controlId="apellido">
                <Form.Label>Apellido</Form.Label>
                <Form.Control
                  type="text"
                  name="apellido"
                  value={values.apellido}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.apellido && !!errors.apellido}

                />
                {errors.apellido && touched.apellido && (
                  <div className="text-danger">{errors.apellido}</div>
                )}
              </Form.Group>

              <Form.Group controlId="telefono">
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  type="text"
                  name="telefono"
                  value={values.telefono}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.telefono && !!errors.telefono}

                />
                {errors.telefono && touched.telefono && (
                  <div className="text-danger">{errors.telefono}</div>
                )}
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.email && !!errors.email}
                />
                {errors.email && touched.email && (
                  <div className="text-danger">{errors.email}</div>
                )}
              </Form.Group>

              <Form.Group controlId="descripcion">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  type="text"
                  name="descripcion"
                  value={values.descripcion}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.descripcion && !!errors.descripcion}

                />
                {errors.descripcion && touched.descripcion && (
                  <div className="text-danger">{errors.descripcion}</div>
                )}
              </Form.Group>

              <Form.Group controlId="valor">
                <Form.Label>Valor</Form.Label>
                <Form.Control
                  type="number"
                  name="valor"
                  value={values.valor}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.valor && !!errors.valor}

                />
                {errors.valor && touched.valor && (
                  <div className="text-danger">{errors.valor}</div>
                )}
              </Form.Group>

              <Form.Group controlId="total_impuesto">
                <Form.Label>Total Impuesto</Form.Label>
                <Form.Control
                  type="number"
                  name="total_impuesto"
                  value={values.total_impuesto}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.total_impuesto && !!errors.total_impuesto}

                />
                {errors.total_impuesto && touched.total_impuesto && (
                  <div className="text-danger">{errors.total_impuesto}</div>
                )}
              </Form.Group>

              <Form.Group controlId="total">
                <Form.Label>Total</Form.Label>
                <Form.Control
                  type
                  name="total"
                  value={values.total}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.total && !!errors.total}

                />
                {errors.total && touched.total && (
                  <div className="text-danger">{errors.total}</div>
                )}
              </Form.Group>

              <Form.Group controlId="impuesto_valor">
                <Form.Label>Impuesto Valor</Form.Label>
                <Form.Control
                  type="number"
                  name="impuesto_valor"
                  value={values.impuesto_valor}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.impuesto_valor && !!errors.impuesto_valor}

                />
                {errors.impuesto_valor && touched.impuesto_valor && (
                  <div className="text-danger">{errors.impuesto_valor}</div>
                )}
              </Form.Group>

              <Form.Group controlId="impuesto_total">
                <Form.Label>Impuesto Total</Form.Label>
                <Form.Control
                  type="number"
                  name="impuesto_total"
                  value={values.impuesto_total}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.impuesto_total && !!errors.impuesto_total}

                />
                {errors.impuesto_total && touched.impuesto_total && (
                  <div className="text-danger">{errors.impuesto_total}</div>
                )}
              </Form.Group>

              <Form.Group controlId="documento_relacionado">
                <Form.Label>Documento Relacionado</Form.Label>
                <Form.Control
                  type="text"
                  name="documento_relacionado"
                  value={values.documento_relacionado}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.documento_relacionado && !!errors.documento_relacionado}

                />
                {errors.documento_relacionado && touched.documento_relacionado && (
                  <div className="text-danger">{errors.documento_relacionado}</div>
                )}

              </Form.Group>

              <Form.Group controlId="info_adicional">
                <Form.Label>Información Adicional</Form.Label>
                <Form.Control
                  type="text"
                  name="info_adicional"
                  value={values.info_adicional}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.info_adicional && !!errors.info_adicional}

                />
                {errors.info_adicional && touched.info_adicional && (
                  <div className="text-danger">{errors.info_adicional}</div>
                )}
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="mt-3"
                disabled={isSubmitting}
              >
                {loading ? 'Creando...' : 'Crear Factura Electrónica'}
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
export default ModalCrearFacturacionElectronica;
